import { Matrix4, Vector3 } from "three";


export function transformVector(v : Vector3, m : Matrix4 | number[] ) : Vector3
{
	const x = v.x, y = v.y, z = v.z, e = (m as Matrix4).elements || (m as number[]);
	return v.set( e[0] * x + e[4] * y + e[8] * z,
		e[1] * x + e[5] * y + e[9] * z,
		e[2] * x + e[6] * y + e[10] * z );
}
export function transformPoint(v : Vector3, m : Matrix4 | number[] ) : Vector3
{
	const x = v.x, y = v.y, z = v.z, e = (m as Matrix4).elements || (m as number[]);
	return v.set( e[0] * x + e[4] * y + e[8] * z + e[12],
		e[1] * x + e[5] * y + e[9] * z + e[13],
		e[2] * x + e[6] * y + e[10] * z  + e[14]);
}
export function untransformVector(v : Vector3, m : Matrix4 | number[] ) : Vector3
{
	const x = v.x, y = v.y, z = v.z, e = (m as Matrix4).elements || (m as number[]);
	return v.set(
		( e[ 0 ] * x + e[ 1 ] * y + e[ 2 ] * z ) / ( e[0] * e[0] + e[1] * e[1] + e[2] * e[2] ),
		( e[ 4 ] * x + e[ 5 ] * y + e[ 6 ] * z ) / ( e[4] * e[4] + e[5] * e[5] + e[6] * e[6] ),
		( e[ 8 ] * x + e[ 9 ] * y + e[ 10 ] * z ) / ( e[8] * e[8] + e[9] * e[9] + e[10] * e[10] ) );
}
export function untransformPoint(v : Vector3, m : Matrix4 | number[] ) : Vector3
{
	const e = (m as Matrix4).elements || (m as number[]);
	const x = v.x - e[12], y = v.y - e[13], z = v.z - e[14]; 
	return v.set(
		( e[ 0 ] * x + e[ 1 ] * y + e[ 2 ] * z ) / ( e[0] * e[0] + e[1] * e[1] + e[2] * e[2] ),
		( e[ 4 ] * x + e[ 5 ] * y + e[ 6 ] * z ) / ( e[4] * e[4] + e[5] * e[5] + e[6] * e[6] ),
		( e[ 8 ] * x + e[ 9 ] * y + e[ 10 ] * z ) / ( e[8] * e[8] + e[9] * e[9] + e[10] * e[10] ) );
}

export function sqrDistanceBetween(m1 : Matrix4 | number[], m2 : Matrix4 | number[]) : number
{
	const e1 = (m1 as Matrix4).elements || (m1 as number[]);
	const e2 = (m2 as Matrix4).elements || (m2 as number[]);
	const dx = e1[12] - e2[12], dy = e1[13] - e2[13], dz = e1[14] - e2[14];
	return dx*dx + dy*dy + dz*dz;
}

export function projectTo(v : Vector3, n : Vector3) : Vector3
{
	const v2 = n.x * n.x + n.y * n.y + n.z * n.z;
	const k = (v2 > 0) ? (v.x * n.x + v.y * n.y + v.z * n.z) / v2 : 0.0;
	return v.set( k * n.x, k * n.y, k * n.z );
}
export function projectFrom(v : Vector3, n : Vector3) : Vector3
{
	const v2 = n.x * n.x + n.y * n.y + n.z * n.z;
	const k = (v2 > 0) ? (v.x * n.x + v.y * n.y + v.z * n.z) / v2 : 0.0;
	return v.set( v.x - k * n.x, v.y - k * n.y, v.z - k * n.z );
}
export function subFromArray(v : Vector3, m : number[], n : number) : Vector3
{
	return v.set( v.x - m[n], v.y - m[n+1], v.z - m[n+2] );
}
